import apiClient from "../lib/apiClient";
import type { AddressDto, AddressResponse, PageResponse } from "./types";

export interface ProgrammeDto {
  title: string;
  subtitle?: string;
  date?: string;
  endDate?: string;
  time?: string;
  endDate?: string | null;
  endTime?: string | null;
  address?: AddressDto;
  addressName?: string;
  lieuId?: string;
  imageLink?: string;
  price?: number;
  tag?: string;
  parcoursId?: string;
}

export interface ProgrammeResponse {
  id: string;
  parcoursId?: string;
  title: string;
  subtitle?: string;
  date?: string;
  endDate?: string;
  time?: string;
  endDate?: string | null;
  endTime?: string | null;
  address?: AddressResponse;
  addressName?: string;
  lieu?: { id: string; name: string };
  imageLink?: string;
  price?: number;
  tag?: string;
  createdAt: string;
  updatedAt: string;
}

export interface ProgrammeSearchParams {
  search?: string;
  parcoursId?: string;
  from?: string;
  to?: string;
  page?: number;
  size?: number;
  sort?: string;
}

export async function listProgrammes(params: ProgrammeSearchParams) {
  const { data } = await apiClient.get<PageResponse<ProgrammeResponse>>("/parcours-programme", { params });
  return data;
}

export async function getProgramme(id: string) {
  const { data } = await apiClient.get<ProgrammeResponse>(`/parcours-programme/${id}`);
  return data;
}

export async function createProgramme(dto: ProgrammeDto) {
  const { data } = await apiClient.post<ProgrammeResponse>("/parcours-programme", dto);
  return data;
}

export async function updateProgramme(id: string, dto: ProgrammeDto) {
  const { data } = await apiClient.put<ProgrammeResponse>(`/parcours-programme/${id}`, dto);
  return data;
}

export async function deleteProgramme(id: string) {
  await apiClient.delete(`/parcours-programme/${id}`);
}
